import { useEffect } from 'react';
import { SpeakingPractice } from './pages/SpeakingPractice';
import { client } from './lib/youbase';
import { useAuthStore } from './store/authStore';

function App() {
  const { setUser, setChecking } = useAuthStore();

  useEffect(() => {
    async function restoreSession() {
      try {
        const session = await client.auth.getSession();
        if (session.data?.user) {
          setUser({
            id: session.data.user.id,
            email: session.data.user.email,
            name: session.data.user.name || '',
          });
        }
      } finally {
        setChecking(false);
      }
    }
    restoreSession();
  }, []);

  return (
    <SpeakingPractice />
  );
}

export default App;
